/**
 * A constant that defines the threshold value used to determine the boundary count
 * for classic editing operations. The Quick Edit would be chaotic for large numbers of boundaries.
 *
 * @constant {number} CLASSIC_EDIT_BOUNDARY_COUNT_THRESHOLD
 */
export const CLASSIC_EDIT_BOUNDARY_COUNT_THRESHOLD = 30;
